import * as ActionTypes from './constants';

export const defaultState = () => ({
  error: null,
  pending: false,
  leads: [],
  leadsCount: null,
});

export function closedLeads(state = defaultState(), action) {
  switch (action.type) {
    case ActionTypes.GET_CLOSED_LEADS_REQUEST:
      return {
        ...state,
        error: null,
        pending: true,
      };
    case ActionTypes.GET_CLOSED_LEADS_SUCCESS:
      return {
        ...state,
        error: null,
        leads: action.payload.sales,
        leadsCount: action.payload.salesCount,
        pending: false,
      };
    case ActionTypes.GET_CLOSED_LEADS_ERROR:
      return {
        ...state,
        error: action.error,
        leads: [],
        leadsCount: null,
        pending: false,
      };
    default:
      return state;
  }
}
